/**
 * Training Analytics — Shared helpers for Stape.io / GTM tracking
 * Used by: main-training-checkout.liquid, main-training-thankyou.liquid
 */
window.TrainingAnalytics = (function() {
  'use strict';

  // ── Attribution capture ──
  // Stores UTM params, click IDs, referrer & cookie-based IDs
  // into sessionStorage so they persist across navigation.
  // Call from landing-page layouts only (not checkout/thankyou).
  function captureAttribution() {
    try {
      if (sessionStorage.getItem('trainingUtmData')) return;
      var p = new URLSearchParams(window.location.search);
      var clickIds = ['fbclid','gclid','gbraid','wbraid','gad_source','gad_campaignid','msclkid','ttclid','dclid','li_fat_id','twclid','sccid','ScCid','irclickid'];
      var hasUtm = p.get('utm_source') || p.get('utm_medium') || p.get('utm_campaign');
      var hasClickId = clickIds.some(function(k) { return p.get(k); });
      if (!hasUtm && !hasClickId && !document.referrer) return;
      function ck(name) {
        var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
        return m ? decodeURIComponent(m[1]) : '';
      }
      sessionStorage.setItem('trainingUtmData', JSON.stringify({
        utm_source: p.get('utm_source') || '',
        utm_medium: p.get('utm_medium') || '',
        utm_campaign: p.get('utm_campaign') || '',
        utm_term: p.get('utm_term') || '',
        utm_content: p.get('utm_content') || '',
        fbclid: p.get('fbclid') || '',
        gclid: p.get('gclid') || '',
        gbraid: p.get('gbraid') || '',
        wbraid: p.get('wbraid') || '',
        gad_source: p.get('gad_source') || '',
        gad_campaignid: p.get('gad_campaignid') || '',
        msclkid: p.get('msclkid') || '',
        ttclid: p.get('ttclid') || '',
        dclid: p.get('dclid') || '',
        li_fat_id: p.get('li_fat_id') || '',
        twclid: p.get('twclid') || '',
        sccid: p.get('sccid') || '',
        ScCid: p.get('ScCid') || '',
        irclickid: p.get('irclickid') || '',
        referrer: document.referrer || '',
        landing_page: window.location.pathname + window.location.search,
        user_agent: navigator.userAgent || '',
        timestamp: new Date().toISOString(),
        _fbc: ck('_fbc'),
        _fbp: ck('_fbp'),
        _ga: ck('_ga')
      }));
    } catch(e) {}
  }

  function centsToPrice(cents) {
    return (cents / 100).toFixed(2);
  }

  function cleanNulls(obj) {
    Object.keys(obj).forEach(function(k) {
      if (obj[k] === null || obj[k] === undefined || obj[k] === '') delete obj[k];
    });
    return obj;
  }

  function buildItems(cart) {
    return cart.items.map(function(item, i) {
      var entry = {
        item_id: item.product_id,
        item_name: item.product_title,
        item_variant: item.variant_id || null,
        variant_name: item.variant_title || null,
        item_category: item.product_type || null,
        item_brand: item.vendor,
        item_url: item.url,
        imageURL: item.image || null,
        item_sku: item.sku || null,
        price: centsToPrice(item.final_price),
        quantity: item.quantity,
        index: i + 1
      };

      if (item.selling_plan_allocation) {
        entry.item_category2 = 'subscription';
        entry.item_category3 = item.selling_plan_allocation.selling_plan ? item.selling_plan_allocation.selling_plan.name : null;
      } else {
        entry.item_category2 = 'one-time';
        entry.item_category3 = 'one-time';
      }

      return cleanNulls(entry);
    });
  }

  // Reads user data from checkout form fields (for checkout page)
  function buildUserDataFromForm() {
    var d = {
      email: (document.getElementById('checkout-email') || {}).value || null,
      phone: (document.getElementById('checkout-phone') || {}).value || null,
      first_name: (document.getElementById('checkout-firstname') || {}).value || null,
      last_name: (document.getElementById('checkout-lastname') || {}).value || null,
      street: (document.getElementById('checkout-address') || {}).value || null,
      city: (document.getElementById('checkout-city') || {}).value || null,
      region: (document.getElementById('checkout-state') || {}).value || null,
      zip: (document.getElementById('checkout-zip') || {}).value || null,
      country: (document.getElementById('checkout-country') || {}).value || null
    };
    return cleanNulls(d);
  }

  // Reads user data from sessionStorage (for thank-you page)
  function buildUserDataFromSession() {
    try {
      var raw = sessionStorage.getItem('trainingCheckoutData');
      if (!raw) return {};
      var d = JSON.parse(raw);
      return cleanNulls({
        email: d.email || null,
        phone: d.phone || null,
        first_name: d.firstName || null,
        last_name: d.lastName || null,
        street: d.address || null,
        city: d.city || null,
        region: d.state || null,
        zip: d.zip || null,
        country: d.country || null
      });
    } catch(e) {
      return {};
    }
  }

  function pushEvent(eventName, cart, options) {
    options = options || {};
    var ecommerce = {
      value: centsToPrice(options.totalCents || cart.total_price),
      currency: cart.currency,
      cart_total: centsToPrice(options.totalCents || cart.total_price),
      cart_quantity: cart.item_count,
      items: buildItems(cart)
    };

    // Extra fields for purchase events
    if (options.transaction_id) ecommerce.transaction_id = options.transaction_id;
    if (options.sub_total !== undefined) ecommerce.sub_total = options.sub_total;
    if (options.tax !== undefined) ecommerce.tax = options.tax;
    if (options.shipping !== undefined) ecommerce.shipping = options.shipping;

    var attr = getAttribution();

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: eventName,
      ecomm_pagetype: options.pageType || 'other',
      user_data: options.userData || {},
      ecommerce: ecommerce,
      // Attribution & click IDs for server-side matching
      attribution: {
        utm_source: attr.utm_source || '',
        utm_medium: attr.utm_medium || '',
        utm_campaign: attr.utm_campaign || '',
        utm_term: attr.utm_term || '',
        utm_content: attr.utm_content || '',
        fbclid: attr.fbclid || '',
        gclid: attr.gclid || '',
        gbraid: attr.gbraid || '',
        wbraid: attr.wbraid || '',
        gad_source: attr.gad_source || '',
        gad_campaignid: attr.gad_campaignid || '',
        msclkid: attr.msclkid || '',
        ttclid: attr.ttclid || '',
        dclid: attr.dclid || '',
        referrer: attr.referrer || '',
        landing_page: attr.landing_page || '',
        _fbc: attr._fbc || '',
        _fbp: attr._fbp || '',
        _ga: attr._ga || ''
      }
    });
  }

  // Reads attribution/UTM data from sessionStorage (captured at landing by layout scripts)
  function getAttribution() {
    try {
      var raw = sessionStorage.getItem('trainingUtmData');
      if (!raw) return {};
      return JSON.parse(raw);
    } catch(e) {
      return {};
    }
  }

  // Helper: fire an event only once per page load
  var _fired = {};
  function pushEventOnce(eventName, cart, options) {
    if (_fired[eventName]) return;
    _fired[eventName] = true;
    pushEvent(eventName, cart, options);
  }

  return {
    captureAttribution: captureAttribution,
    centsToPrice: centsToPrice,
    buildItems: buildItems,
    buildUserDataFromForm: buildUserDataFromForm,
    buildUserDataFromSession: buildUserDataFromSession,
    getAttribution: getAttribution,
    pushEvent: pushEvent,
    pushEventOnce: pushEventOnce
  };
})();
